import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { replaceNullWithUndefined } from "helpers/formatObject";
import {
  FetchProjectReportRequestPayloadInterface,
  FetchProjectReportToPDFRequestPayloadInterface,
  ProjectReportStateInterface
} from "./interfaces";

const initialState: ProjectReportStateInterface = {
  isLoading: false,
  projectReport: null
};

export const mainSlice = createSlice({
  name: "projectReport",
  initialState,
  reducers: {
    fetchProjectReportRequest: (
      state,
      _: PayloadAction<FetchProjectReportRequestPayloadInterface>
    ) => {
      state.isLoading = true;
    },
    fetchProjectReportSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.projectReport = replaceNullWithUndefined(payload);
    },
    fetchProjectReportError: (state) => {
      state.isLoading = false;
    },

    fetchProjectReportToPDFRequest: (
      state,
      _: PayloadAction<FetchProjectReportToPDFRequestPayloadInterface>
    ) => {
      state.isLoading = true;
    },
    fetchProjectReportToPDFSuccess: (state) => {
      state.isLoading = false;
    },
    fetchProjectReportToPDFError: (state) => {
      state.isLoading = false;
    }
  }
});

export const { actions, reducer } = mainSlice;
